const prices = [
  {
    name: "staander_150x150",
    label: "Staander",
    unit: "m",
    price: 0,
  },
  {
    name: "standdeer_110x110",
    label: "Staander",
    unit: "m",
    price: 0,
  },

  {
    name: "glass",
    label: "Glasplaat dak 44.2",
    unit: "m²",
    price: 0,
  },
  {
    name: "glassdark",
    label: "Glasplaat dak 55.2",
    unit: "m²",
    price: 0,
  },
  {
    name: "glassMelk",
    label: "Glasplaat dak melkglas",
    unit: "m²",
    price: 64,
  },
  {
    name: "polylight",
    label: "Polycarbonaat Opaal",
    unit: "m²",
    price: 0,
  },
  {
    name: "polymid",
    label: "Polycarbonaat Helder",
    unit: "m²",
    price: 0,
  },
  {
    name: "polydark",
    label: "Polycarbonaat Zonwerend",
    unit: "m²",
    price: 32.25,
  },
  {
    name: "polywide",
    label: "Breed helder polycarbonaat",
    unit: "m²",
    price: 34.5,
  },
  {
    name: "polyOpMaat",
    label: "Poly op maat gezaagd",
    unit: "stuk",
    price: 15,
  },

  {
    name: "goot",
    label: "Gootprofiel",
    unit: "m",
    price: 0,
  },
  {
    name: "ligger_165x200",
    label: "Ligger 165x200",
    unit: "m",
    price: 0,
  },
  {
    name: "ligger",
    label: "Ligger",
    unit: "m",
    price: 0,
  },
  {
    name: "middenAfdekker",
    label: "Middenafdekker",
    unit: "m",
    price: 0,
  },
  {
    name: "plaatstopper",
    label: "Plaatstopper",
    unit: "stuk",
    price: 0,
  },
  {
    name: "muurplaat",
    label: "Muurprofiel",
    unit: "m",
    price: 0,
  },
  {
    name: "condensprofiel",
    label: "Condensprofiel",
    unit: "stuk",
    price: 0,
  },

  {
    name: "gootprofiel",
    label: "Gootprofiel",
    unit: "m",
    price: 0,
  },
  {
    name: "gootsierlijstCube",
    label: "Gootsierlijst",
    unit: "m",
    price: 0,
  },
  {
    name: "afdekkapGootprofiel",
    label: "Afdekkap gootprofiel",
    unit: "stuk",
    price: 0,
  },
  {
    name: "liggerVelvetline",
    label: "Liggers, incl. rubber",
    unit: "m",
    price: 0,
  },
  {
    name: "liggerVerzwaring",
    label: "Ligger Verzwaring",
    unit: "m",
    price: 0,
  },
  {
    name: "zijAfdekker",
    label: "Zijafdekker, incl. afdekrubber",
    unit: "m",
    price: 0,
  },
  {
    name: "middenAfdekkerVelvetline",
    label: "Middenafdekker, incl. afdekrubber",
    unit: "m",
    price: 0,
  },
  {
    name: "muurplaatVelvetline",
    label: "Muurprofiel, incl.rubber",
    unit: "m",
    price: 0,
  },
  {
    name: "afdekkapmuurprofiel",
    label: "Afdekkap muurprofiel",
    unit: "stuk",
    price: 0,
  },
  {
    name: "gootsierlijstKlassiek",
    label: "Gootsierlijst Klassiek",
    unit: "m",
    price: 16.11,
  },
  {
    name: "gootsierlijstRond",
    label: "Gootsierlijst Rond",
    unit: "m",
    price: 14.54,
  },
  {
    name: "condensprofielVelvetline",
    label: "Condensprofiel",
    unit: "stuk",
    price: 0,
  },
  {
    name: "velvetlinePlaatstopper",
    label: "Plaatstopper",
    unit: "stuk",
    price: 0,
  },

  {
    name: "spyFrame",
    label: "Spie Frame",
    unit: "m",
    price: 100,
  },
  {
    name: "polycarbonatSpy",
    label: "Spie Polycarbonat",
    unit: "m²",
    price: 100,
  },
  {
    name: "polycarbonatWideSpy",
    label: "Spie Breed helder polycarbonaat",
    unit: "m²",
    price: 100,
  },
  {
    name: "glassSpy",
    label: "Glasspie met gelaagd glas 55.2",
    unit: "m²",
    price: 325,
  },
  {
    name: "glassSpy44",
    label: "Glasspie met gelaagd glas 44.2",
    unit: "m²",
    price: 279,
  },
  {
    name: "polycarbonaatSpie",
    label: "Polycarbonaat spie",
    unit: "m²",
    price: 83.33,
  },

  {
    name: "sunScreenBody",
    label: "Zonwering Body",
    unit: "m",
    price: 100,
  },
  {
    name: "sunScreenBovendakOnderdak",
    label: "Zonwering bovendak of onderdak",
    unit: "stuk",
    price: 0,
  },
  {
    name: "sunScreenSideGuide",
    label: "Zonwering SideGuide",
    unit: "m",
    price: 115,
  },
  {
    name: "sunScreenGuideMountingBracketsBottom",
    label: "Zonwering Brackets",
    unit: "m",
    price: 103.5,
  },
  {
    name: "sunScreenGuideMountingBracketsTop",
    label: "Zonwering Brackets",
    unit: "m",
    price: 103.5,
  },
  {
    name: "sunScreenGuideMountingBracketsTopVelvetline",
    label: "Zonwering Brackets",
    unit: "m",
    price: 103.5,
  },
  {
    name: "sunScreenTextile",
    label: "Zonwering Textile",
    unit: "m²",
    price: 115,
  },
  {
    name: "sunScreenMolding",
    label: "Zonwering Molding",
    unit: "m",
    price: 115,
  },
  {
    name: "spotlight",
    label: "Verlichting",
    unit: "stuk",
    price: 37.5,
  },

  {
    name: "unevenwidth",
    label: "Maatwerk breedte",
    unit: "stuk",
    price: 0,
  },
  {
    name: "unevendepth",
    label: "Maatwerk diepte",
    unit: "stuk",
    price: 0,
  },
  {
    name: "montageset",
    label: "Montageset",
    unit: "stuk",
    price: 0,
  },
  {
    name: "pvcBuis",
    label: "PVC buis",
    unit: "stuk",
    price: 0,
  },
  {
    name: "pvcBocht90gr",
    label: "PVC bocht 90gr",
    unit: "stuk",
    price: 0,
  },
  {
    name: "toeslagProductie",
    label: "Toeslag op verkoopprijs voor productie",
    unit: "stuk",
    price: 0,
  },

  {
    name: "aluminiumWall",
    label: "Aluminium Zijwand volledig dicht",
    unit: "m",
    price: 455,
  },
  {
    name: "aluminiumWallPolySpie",
    label: "Aluminium Zijwand met poly spie",
    unit: "m",
    price: 389,
  },
  {
    name: "aluminiumWallStaandePoly",
    label: "Aluminium Zijwand met staande poly",
    unit: "m",
    price: 344,
  },
  {
    name: "glassdoors",
    label: "Glazen schuifwand",
    unit: "stuk",
    price: 425,
  },
  {
    name: "glassdoorsdark",
    label: "Glazen schuifwand donker",
    unit: "stuk",
    price: 69,
  },
  {
    name: "windowdoors",
    label: "Steellook schuifwand",
    unit: "stuk",
    price: 175,
  },
  {
    name: "windowdoorsdark",
    label: "Steellook schuifwand donker",
    unit: "stuk",
    price: 0,
  },

  {
    name: "doorBrushes",
    label: "Tochtborstels",
    unit: "stuk",
    price: 26,
  },
  {
    name: "stainlessSteelHandle",
    label: "Handgreep RVS",
    unit: "stuk",
    price: 0,
  },
  {
    name: "lockProfile",
    label: "Vergrendelprofiel",
    unit: "stuk",
    price: 62.5,
  },
  {
    name: "schuifrichting",
    label: "Schuifrichting",
    unit: "stuk",
    price: 0,
  },
  {
    name: "glasbok_zwart",
    label: "Glasbok zwart",
    unit: "stuk",
    price: 30,
  },
  {
    name: "glasbok_antraciet",
    label: "Glasbok antraciet",
    unit: "stuk",
    price: 30,
  },
  {
    name: "glasbok_wit",
    label: "Glasbok wit",
    unit: "stuk",
    price: 30,
  },
  {
    name: "poer",
    label: "Poer",
    unit: "stuk",
    price: 45,
  },
  {
    name: "hwapoer",
    label: "HWA Poer",
    unit: "stuk",
    price: 90,
  },
  {
    name: "fundering",
    label: "Fundatiekoker",
    unit: "m",
    price: 60,
  },

  {
    name: "kliklijst",
    label: "Kliklijst (voor goot en muurprofiel)",
    unit: "m",
    price: 0,
  },
  {
    name: "opslagGlasplaatDak",
    label: "Opslag glasplaat dak",
    unit: "%",
    price: 0,
  },
  {
    name: "montage",
    label: "Montage",
    unit: "%",
    price: 27,
  },
];

export default prices;
